import request from '@/utils/request'

export function getRewardRecordList(data) {
  return request({
    url: 'api/v1/reward-record/getList',
    method: 'post',
    data: data,
    timeout: 1000000
  })
}

export function getUserOrderProcess(data) {
  return request({
    url: 'api/v1/user/getUserOrderProcess',
    method: 'post',
    data: data,
    timeout: 1000000
  })
}

export function getUserOrderProcessData(data) {
  return request({
    url: 'api/v1/user/getUserOrderProcessData',
    method: 'post',
    data: data,
    timeout: 1000000
  })
}

export function getMiningRecord(data) {
  return request({
    url: 'api/v1/reward-record/miningRecord',
    method: 'post',
    data: data
  })
}

export function getRewardRecordListV2(data) {
  return request({
    url: 'api/v1/reward-record/getListV2',
    method: 'post',
    data: data
  })
}

export function exportReward(data) {
  return request({
    url: 'api/v1/reward-record/export',
    method: 'post',
    data: data,
    timeout: 100000
  })
}

export function getActRewardRecordList(data) {
  return request({
    url: 'api/v1/reward-record/getActList',
    method: 'post',
    data: data
  })
}

export function getRidTypeList() {
  return request({
    url: 'api/v1/reward-record/ridTypeList',
    method: 'get'
  })
}

export function exportSpinsConsume(data) {
  return request({
    url: 'api/v1/user/exportSpinsConsume',
    method: 'post',
    data: data,
    timeout: 5000000
  })
}
